import { CARD_IMAGE_RATIO_OPTIONS } from '../../app-ui-settings/catalog.js';
export const SCREEN_GAP_OPTIONS = [
    { value: 'default', label: '기본(지금 앱 간격)' },
    { value: 'none', label: '없음(0px)' },
    { value: 'xs', label: 'spacing/xs(4px)' },
    { value: 's', label: 'spacing/s(8px)' },
    { value: 'm', label: 'spacing/m(12px)' },
    { value: 'm-plus', label: 'spacing/m-plus(16px)' },
    { value: 'l', label: 'spacing/l(20px)' },
    { value: 'l-plus', label: 'spacing/l-plus(24px)' },
];
export const DETAIL_IMAGE_RATIO_OPTIONS = CARD_IMAGE_RATIO_OPTIONS;
//# sourceMappingURL=options.js.map